import React from 'react';
import { Helmet } from 'react-helmet';

function Fonts() {
    return (
        <Helmet>
            <link
                href="https://fonts.googleapis.com/css2?family=Libre+Franklin:wght@300;400;500;600;700&display=swap"
                rel="stylesheet"
            />

            <link
                href="https://fonts.googleapis.com/css2?family=Montserrat:wght@200;300;400;500;600;700;800;900&display=swap"
                rel="stylesheet"
            />
        </Helmet>
    );
}

export default Fonts;